export class SetupFiscalYearRequest {
  propertyId: string;
  fiscalYear: number;
  // startingReserveBalance: number;
  // annualReserveContribution: number;
  inflationRate: number;
  informationSourceId: number;
  extendLifeComponentIds: string[];
  updateCurrentYear: boolean;
}
